import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface ContentContainerProps {
  children: ReactNode;
  className?: string;
}

export function ContentContainer({ children, className }: ContentContainerProps) {
  return (
    <div className={cn("max-w-[1400px] mx-auto px-6 md:px-8 py-8 w-full", className)}>
      {children}
    </div>
  );
}
